export type CustomerSupport = false | null | undefined | { enabled?: boolean | null };

/**
 * Normalizes the inconsistent `customerSupport` payload returned by the project configuration.
 *
 * This helper is intentionally kept outside the store and UI so the application has a single,
 * explicit rule for interpreting all backend variants (`null`, `undefined`, `false`, `{}`,
 * or `{ enabled: boolean }`) as a stable boolean.
 */
export const isCustomerSupportEnabled = (customerSupport?: CustomerSupport): boolean => {
  return customerSupport !== null && typeof customerSupport === 'object' && customerSupport.enabled === true;
};
